<mat-autocomplete class="common-search-panel" #auto="matAutocomplete">
  <div class="options-container">
    <div class="recent-search-label" *ngIf="results?.[0]?.isRecentSearch">Recent Searches</div>
    <mat-option
      *ngFor="let result of results | slice : 0 : 10"
      [value]="result"
      (click)="searchResultNavigate(result)"
    >
      <div class="person-result-container" *ngIf="result.recordType === 'person'">
        <div class="person-result">
          <div class="avatar-container">
            <img *ngIf="result.photoUrl" [src]="result.photoUrl" class="result-photo" />
            <span *ngIf="!result.photoUrl" class="result-initials">
              {{ result.name | initials }}
            </span>
          </div>
          <div class="bio-container">
            {{ result.name }}
            <div class="result-subtitle">
              {{ result.title ? result.title : null
              }}{{
                result?.location?.officeAffiliation?.name
                  ? " | " + result?.location?.officeAffiliation?.name
                  : ""
              }}
            </div>
          </div>
        </div>
        <div class="remove-person-button" *ngIf="result.isRecentSearch">
          <mat-icon (click)="removeRecentSearch($event, result)">close</mat-icon>
        </div>
      </div>
    </mat-option>
  </div>

  <div class="divider"></div>
  <div *ngIf="searchValue" class="results-link">
    <a (click)="searchResultNavigate(searchValue)">see all results</a>
  </div>
</mat-autocomplete>

<!-- Desktop Search -->
<div fxHide [fxShow.gt-md]="true" class="input-container" cdkScrollable>
  <mat-icon class="search-icon">search</mat-icon>
  <input
    type="search"
    class="input-search"
    placeholder="Search for Team Members"
    [(ngModel)]="searchValue"
    [matAutocomplete]="auto"
    [formControl]="myControl"
    (keydown.enter)="searchResultNavigate(searchValue)"
    (keyup)="valuechange($event)"
    (focus)="openAutocomplete()"
    #trigger="matAutocompleteTrigger"
  />
</div>

<!-- Mobile Search -->
<div fxHide [fxShow.lt-lg]="searchActive" class="custom-search" cdkScrollable>
  <mat-icon class="mobile-search-icon">search</mat-icon>
  <input
    *ngIf="searchActive"
    type="search"
    class="search-icon-expand"
    placeholder="Search for Team Members"
    [(ngModel)]="searchValue"
    [matAutocomplete]="auto"
    [formControl]="myControl"
    (keydown.enter)="searchResultNavigate(searchValue)"
    (keyup)="valuechange($event)"
    (blur)="retractSearchBar()"
    (keydown.enter)="clearSearch()"
    (keydown.enter)="retractSearchBar()"
    appSearchFocus
  />
  <button class="search-btn" type="submit"></button>
</div>
